export const ROUTE = {
  HOME: {
    LINK: '/',
  },
  DASHBOARD: {
    LINK: '/dashboard',
    NAME: 'dashboard',
  },
  CONVERSATION: {
    LINK: '/conversation',
    NAME: 'conversation',
  },
  CONVERSATION_MANAGE: {
    LINK: '/conversation/[user_id]',
    NAME: 'conversation-user_id',
  },
  CONVERSATION_MANAGE_DETAIL: {
    LINK: '/conversation/[user_id]/[chat_id]',
    NAME: 'conversation-user_id-chat_id',
  },
  PRESET: {
    LINK: '/preset',
    NAME: 'preset',
  },
  PRESET_MANAGE: {
    LINK: '/preset/[id]',
    NAME: 'preset-id',
  },
  QUOTA: {
    LINK: '/quota',
    NAME: 'quota',
  },
  QUOTA_MANAGE: {
    LINK: '/quota/[quota_id]',
    NAME: 'quota-quota_id',
  },
  APPLICATION: {
    LINK: '/access-management/applications',
    NAME: 'access-management-applications',
  },
  APPLICATION_MANAGE: {
    LINK: '/access-management/applications/[application_id]',
    NAME: 'access-management-applications-application_id',
  },
  SCOPE: {
    LINK: '/access-management/scopes',
    NAME: 'access-management-scopes',
  },
  SCOPE_MANAGE: {
    LINK: '/access-management/scopes/[scope_id]',
    NAME: 'access-management-scopes-scope_id',
  },
  USER: {
    LINK: '/access-management/users',
    NAME: 'access-management-users',
  },
  USER_MANAGE: {
    LINK: '/access-management/users/[user_id]',
    NAME: 'access-management-users-user_id',
  },
  TOKEN_USAGE_REPORT: {
    LINK: '/report/token-usage',
    NAME: 'report-token-usage',
  },
  TOKEN_USAGE_REPORT_DETAIL: {
    LINK: '/report/token-usage/[user_id]',
    NAME: 'report-token-usage-user_id',
  },
  TOKEN_USAGE_REPORT_DETAIL_HISTORY_DETAIL: {
    LINK: '/report/token-usage/[user_id]/[id]',
    NAME: 'report-token-usage-user_id-id',
  },
  // APPLICATION: {
  //   LINK: '/access-management/application',
  // },
  // APPLICATION_MANAGE: {
  //   LINK: '/access-management/application/[id]',
  // },
  // SCOPE: {
  //   LINK: '/access-management/scope',
  // },
  // SCOPE_MANAGE: {
  //   LINK: '/access-management/scope/[scope_id]',
  // },
  // USER: {
  //   LINK: '/access-management/user',
  // },
  // USER_MANAGE: {
  //   LINK: '/access-management/user/[user_id]',
  // },
  LOGIN: {
    LINK: '/login',
  },
  WORKFLOW: {
    LINK: '/workflow',
    NAME: 'workflow',
  },
  WORKFLOW_MANAGE: {
    LINK: '/workflow/[id]',
    NAME: 'workflow-id',
  },
  KNOWLEDGE: {
    LINK: '/knowledge',
    NAME: 'knowledge',
  },
  KNOWLEDGE_MANAGE: {
    LINK: '/knowledge/[id]',
    NAME: 'knowledge-id',
  },
  PROMPT: {
    LINK: '/prompt-library',
    NAME: 'prompt-library',
  },
};
